import { GenericLandingCardInterface } from "../../interfaces";
import logo from "../../assets/images/logo_es.svg";

export const GenericLandingCard = (children: GenericLandingCardInterface) => {
  return (
    <section className="bg-card__ flex-container column justify-between">
      <div className="flex-container gap-12 top-row-container">
        <div className="logo-container">
          <img src={logo} alt="logo" />
        </div>
        <div className="right-column-container">{children.rightColumn}</div>
      </div>

      <div className="flex-container justify-between bottom-row-container">
        <div>{children.leftInteraction}</div>
        <div className="width-50">{children.rightInteraction}</div>
      </div>
    </section>
  );
};
